import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav } from 'react-bootstrap'; // Import Navbar and Nav
import phoneIcon from '../images/phone 1.svg';
import emailIcon from '../images/email 1.svg';
import logoImage from '../images/NH medical-logo_Mian-02.png';

function Header() {
  return (
    <div className="d-flex flex-column align-items-start w-100">
      {/* Top Bar with Contact Info */}
      <div className="bg-white py-0 px-5 d-flex flex-wrap gap-1 gap-md-4 align-items-center w-100 ">
        <div className="d-flex flex-row gap-2 align-items-center">
          <img src={phoneIcon} alt="Phone Icon" className="phone-icon" style={{ width: '20px', height: '20px' }} />
          <div className="fw-medium">+84 941 144 333</div>
        </div>
        <div className="d-flex flex-row gap-2 align-items-center">
          <img src={emailIcon} alt="Email Icon" className="style-fill"  style={{ width: '20px', height: '20px' }} />
          <div className="fw-medium">nguyenhoang@nhmed.com.vn</div>
        </div>
      </div>

      {/* Responsive Navigation Bar */}
      <Navbar expand="lg" className="w-100 bg-dark" > {/* Use Navbar component, expand on larger screens */}
        <div className="container-fluid">
          <Navbar.Brand className="ms-4" href="/"> {/* Wrap logo in Navbar.Brand for styling */}
            <img
              src={logoImage}
              alt="NH Icon"
              style={{ height: '60px', objectFit: 'contain' }} // Set width and object fit for logo
              className="d-inline-block align-top" // Bootstrap classes for image alignment
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="bg-white" /> {/* Hamburger button */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-start"> {/* Collapsible navigation links */}
            <Nav className="bg-dark py-2 px-md-4 gap-md-3">
              <Nav.Link href="/" className="text-white">Home</Nav.Link>
              <Nav.Link href="/about" className="text-white">About</Nav.Link>
              <Nav.Link href="/products" className="text-white">Product</Nav.Link>
              <Nav.Link href="/contact" className="text-white">Contact</Nav.Link>
              <Nav.Link href="/news" className="text-white">News</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </div>
  );
}

export default Header;